/** @format */

import React, { useState } from "react";
import dictionaryApi from "../Apis/dictionaryApi";
import PexelsApi from "../Apis/PexelsApi";
import Result from "./Results";
import "../Style/Search.css";

const Search = () => {
  const [term, setTerm] = useState("sunset");
  const [result, setResult] = useState(null);
  const [images, setImages] = useState(null);
  let [loaded, setLoaded] = useState(false);

  const findMeans = () => {
    dictionaryApi.get(`/${term}`).then((res) => setResult(res.data[0]));
  };

  const findImages = async () => {
    await PexelsApi.get("/search", {
      params: {
        query: term,
      },
    }).then((res) => {
      setImages(res.data.photos);
    });
  };
  const load = () => {
    setLoaded(true);
    findMeans();
    findImages();
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    findMeans();
    findImages();
  };

  if (loaded) {
    return (
      <div>
        {" "}
        <div className="container-fluid mt-5  header">
          <div className="search">
            <div className="row">
              <div className="col-3 my-auto ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 119 54"
                  fillRule="evenodd"
                  data-v-df3bdae8="">
                  <path
                    d="M9.02 47.713c0 2.106-1.443 3.548-3.582 3.548H3.42v-7.164h2.02c2.14 0 3.582 1.477 3.582 3.582zm-3.58-5.976H.805V53.62H5.44c3.735 0 6.315-2.596 6.315-5.94v-.034c0-3.345-2.58-5.908-6.315-5.908zm9.436 11.883H17.5V41.738h-2.614zm11.917-2.206c-2.037 0-3.446-1.698-3.446-3.735v-.034c0-2.038 1.443-3.702 3.446-3.702 1.188 0 2.123.5 3.04 1.342l1.664-1.918c-1.103-1.087-2.444-1.834-4.686-1.834-3.65 0-6.196 2.767-6.196 6.146v.033c0 3.412 2.597 6.1 6.094 6.1 2.292 0 3.65-.815 4.872-2.122l-1.663-1.68c-.934.85-1.765 1.392-3.124 1.392m7.4-7.264h2.9v9.473h2.614v-9.473h2.908v-2.4h-8.432zm11.232 9.472h2.614V41.738h-2.614zm15.634-5.907c0 2.037-1.46 3.7-3.565 3.7s-3.6-1.698-3.6-3.735v-.034c0-2.038 1.46-3.702 3.565-3.702s3.6 1.698 3.6 3.735zm-3.565-6.18c-3.667 0-6.332 2.767-6.332 6.146v.033c0 3.378 2.63 6.1 6.298 6.1s6.332-2.767 6.332-6.145v-.034c0-3.38-2.63-6.112-6.298-6.112zm44.715 4.237c0 .968-.73 1.625-2.003 1.625H97.57v-3.3h2.597c1.273 0 2.054.557 2.054 1.64zm-1.833-4.034h-5.433V53.62h2.614v-3.802h2.054l1.856 3.802h3.024l-2.18-4.244c1.5-.56 2.546-1.766 2.546-3.684v-.034c0-1.12-.356-2.054-1.02-2.716-.78-.78-1.952-1.205-3.462-1.205zM74.754 47.45l-7.77-5.724-.025 11.904h2.886l-.016-6.233 7.758 6.224.001-11.926h-2.835zm9.704 1.594l1.65-4.026 1.65 4.026zm.426-7.306l-5.064 11.9h2.785l.878-2.2h5.25l.953 2.2h2.855l-5.138-11.9zM115 41.75l-2.903 4.2-2.818-4.2h-3.18l4.67 6.922.02 4.962h2.615l.058-4.962 4.643-6.922z"
                    fill="#3790ce"></path>
                  <path
                    d="M13.458 11.74L7.002 2.407H0l10.415 15.86.047 11.738h6l.13-11.738 10.332-15.86H20.1zm64.82 6.412c0 4.287-2.105 6.488-5.576 6.488s-5.576-2.28-5.576-6.68V2.42h-5.687v15.693c0 7.956 4.247 12 11.2 12s11.336-4.017 11.336-12.204V2.42h-5.687zm25.063-4.447c-.84.577-1.935.772-2.938.772h-4.207V8.134h3.08c1.392 0 3-.134 4.18.73.73.528 1.083 1.424 1.084 2.33.003.98-.408 1.97-1.2 2.513zm1.817 5.372c3.438-1.275 5.794-3.3 5.794-7.665v-.077c0-5.562-3.824-8.922-10.196-8.922H90.54V29.93h5.948v-9.85h2.528l5.794 9.85h6.95z"
                    fill="#f79820"></path>
                  <path
                    d="M22.533 38.343L20.42 36.23a1.68 1.68 0 010-2.378l7.065-7.065 4.49 4.492-7.065 7.065a1.68 1.68 0 01-2.378 0"
                    fill="#404042"></path>
                  <path
                    d="M41.424.575a15.31 15.31 0 00-15.307 15.307 15.24 15.24 0 003.047 9.167.96.96 0 00-.156.104l-1.12 1.122a.68.68 0 000 .964l3.48 3.482a.68.68 0 00.964 0l1.122-1.122a.67.67 0 00.19-.535 15.223 15.223 0 007.78 2.126 15.31 15.31 0 0015.307-15.307A15.31 15.31 0 0041.424.575"
                    fill="#fefefe"></path>
                  <path
                    d="M54 15.882a12.58 12.58 0 01-12.576 12.576 12.58 12.58 0 01-12.576-12.576A12.58 12.58 0 0141.423 3.306a12.58 12.58 0 0112.576 12.576"
                    fill="#7fd2f0"></path>
                  <path
                    d="M41.423 21.8c-4.797 0-8.8-3.395-9.74-7.913a10 10 0 00-.209 2.036 9.95 9.95 0 009.949 9.949 9.95 9.95 0 009.949-9.949 10 10 0 00-.209-2.036c-.94 4.518-4.943 7.913-9.74 7.913"
                    fill="#ade5fb"></path>
                  <path
                    d="M41.424 30.615c-2.665 0-5.165-.715-7.324-1.958a14.84 14.84 0 01-4.67-4.234 14.65 14.65 0 01-2.74-8.54C26.7 7.76 33.3 1.15 41.424 1.15s14.733 6.6 14.733 14.733-6.6 14.734-14.733 14.734zm-9.47-.274a.145.145 0 01-.206 0l-3.482-3.482a.143.143 0 010-.205l.805-.806a16.05 16.05 0 003.903 3.472zM41.424 0c-8.757 0-15.882 7.124-15.882 15.882a15.79 15.79 0 002.877 9.101l-.913.913a1.21 1.21 0 000 1.723l3.482 3.483a1.216 1.216 0 001.722 0l1.12-1.122c.032-.032.058-.07.086-.104a15.78 15.78 0 007.506 1.89c8.757 0 15.88-7.124 15.88-15.882S50.18 0 41.424 0zm0 27.866A12 12 0 0129.44 15.882 12 12 0 0141.424 3.898a12 12 0 0111.984 11.984 12 12 0 01-11.984 11.984m0-25.152c-7.26 0-13.168 5.906-13.168 13.168S34.163 29.05 41.424 29.05 54.6 23.143 54.6 15.882 48.685 2.714 41.424 2.714m-19.708 33.54l-.2-.204a.43.43 0 01-.007-.609l5.998-6.122a.43.43 0 01.609-.007l.2.204a.43.43 0 01.006.61l-5.998 6.12a.43.43 0 01-.61.007"
                    fill="#a0a0a2"></path>
                </svg>
              </div>
              <div className="col-9 my-auto">
                <form onSubmit={onFormSubmit}>
                  <div className="searchBar">
                    <input
                      id="searchQueryInput"
                      type="text"
                      name="searchQueryInput"
                      placeholder="Search ..."
                      onChange={(e) => setTerm(e.target.value)}
                    />
                    <button
                      id="searchQuerySubmit"
                      type="submit"
                      name="searchQuerySubmit">
                      <svg viewBox="0 0 24 24" id="small">
                        <path
                          fill="#F5F2F2"
                          d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                        />
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Result data={result} images={images} />
      </div>
    );
  } else {
    load();
    return "loading";
  }
};
export default Search;
